<script>
import BaseInfo from './BaseInfo'
export default {
  name: 'SeoConfig',
  extends: BaseInfo,
  data () {
    return {
      formListKey: 'formListSeo'
    }
  }
}
</script>
